import { HOMEPAGE_SLUG } from '@constants/slugs'

export const isHomepage = (pageSlug: string): boolean => pageSlug === HOMEPAGE_SLUG
